import { render, staticRenderFns } from "./SewerPump.vue?vue&type=template&id=52c97b01&"
import script from "./SewerPump.vue?vue&type=script&lang=js&"
export * from "./SewerPump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports